import type { SpreadsheetFillRangeMode } from '../protocol/spreadsheetEngineProtocol'
import type { SpreadsheetCommandId } from './commandRegistry'

export type FillOptionCommandDescriptor = {
  id: SpreadsheetCommandId
  action: string
  mode: SpreadsheetFillRangeMode
  requiresSeries: boolean
}

export type FillOptionMenuEntry = FillOptionCommandDescriptor & {
  disabled: boolean
}

export const FILL_OPTION_COMMANDS: FillOptionCommandDescriptor[] = [
  { id: 'fill-copy-cells', action: 'fill-copy-cells', mode: 'copyCells', requiresSeries: false },
  { id: 'fill-series', action: 'fill-series', mode: 'fillSeries', requiresSeries: true },
  { id: 'fill-days', action: 'fill-days', mode: 'fillDays', requiresSeries: false },
  { id: 'fill-weekdays', action: 'fill-weekdays', mode: 'fillWeekdays', requiresSeries: false },
  { id: 'fill-months', action: 'fill-months', mode: 'fillMonths', requiresSeries: false },
  { id: 'fill-years', action: 'fill-years', mode: 'fillYears', requiresSeries: false },
]

export function fillOptionCommandForAction(action: string): FillOptionCommandDescriptor | null {
  return FILL_OPTION_COMMANDS.find((command) => command.action === action) ?? null
}

export function buildFillOptionsMenuEntries(args: {
  canFillSeries?: boolean | null
}): FillOptionMenuEntry[] {
  const canFillSeries = Boolean(args.canFillSeries)
  return FILL_OPTION_COMMANDS.map((command) => ({
    ...command,
    disabled: command.requiresSeries && !canFillSeries,
  }))
}
